// extracted by mini-css-extract-plugin
export var clickThrough = "_yd-2";
export var fallback = "_yd-5";
export var frame = "_yd-3";
export var frameCell = "_yd-1";
export var overlay = "_yd-4";
export var wrapper = "_yd-0";